import React, { useEffect } from "react";
import { Layout, Row, Col, Button } from "antd";
import WorkOrderCarpentryC from "../../containers/work-order/work-order-carpentry/WorkOrderCarpentryC";
import JobJacketSteps from "./JobJacketSteps";
import { useHistory, useParams } from "react-router-dom";
import useSyncProjectData from "../../utils/useSyncProjectData";
import { Spin } from "antd";

const { Content } = Layout;

const WorkOrderCarpentry: React.FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
  }, []);
  const handleNext = () => {
    history.push(`/paint-order/${id}`);
  };
  const [isLoading] = useSyncProjectData(id);

  return (
    <>
      {isLoading === true ? (
        <Row style={{ padding: "80px 0px" }} justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <Content>
          <JobJacketSteps current={2} />
          <div className="steps-content">
            <Row gutter={24}>
              <Col className="gutter-row" span={24}>
                <WorkOrderCarpentryC />
              </Col>
            </Row>
          </div>
          <div className="onsite-btn-container">
            <Row gutter={12} justify="center">
              <Col>
                <Button
                  onClick={handleNext}
                  type="primary"
                  className="save-button"
                >
                  Next
                </Button>
              </Col>
            </Row>
          </div>
        </Content>
      )}
    </>
  );
};

export default WorkOrderCarpentry;
